import { ITradeUnionMember } from 'app/api/tradeUnionMembers/model'
import { TumInfoLayout } from 'app/containers/Profile/layouts'

export const InfoLayout = ({ tum }: { tum?: ITradeUnionMember }) => {
  return <TumInfoLayout tum={tum} />
}
